import React from 'react';
import styled from 'styled-components';

import { Loupe, ResentlyBuy, Seaview } from '@lt/components/icons-react';
import DynamicDataBlock from '../DynamicDataBlock';

import type { DynamicDataArrayProps } from './types';

const DynamicDataArray = ({
  latestOrder,
  hotPriceByCountry,
  foundToursToday,
  isMobile,
  isLoading = false,
  isWhitelabel = false,
}: DynamicDataArrayProps): JSX.Element => (
  <Container $isMobile={isMobile} $isWhitelabel={isWhitelabel}>
    <DynamicDataBlock
      icon={<StyleLoupe />}
      text={`Найдено туров за сутки\n${Number(foundToursToday).toLocaleString(
        'ru',
      )}`}
      isLoading={!foundToursToday && isLoading}
      isMobile={isMobile}
      order={isMobile ? 1 : 3}
    />
    <DynamicDataBlock
      icon={<StyleResentlyBuy />}
      text={
        latestOrder ? `${latestOrder.title}\n${latestOrder.descriptions}` : ''
      }
      isLoading={!latestOrder && isLoading}
      isMobile={isMobile}
      order={isMobile ? 2 : 1}
    />
    <DynamicDataBlock
      icon={<StyleSeaview />}
      text={
        hotPriceByCountry
          ? `Самые дешевые туры\n ${hotPriceByCountry.name} от ${Number(
              hotPriceByCountry.price,
            ).toLocaleString('ru')} ₽/чел.`
          : ''
      }
      isLoading={!hotPriceByCountry && isLoading}
      isMobile={isMobile}
      order={isMobile ? 3 : 2}
    />
  </Container>
);

const StyleLoupe = styled(Loupe)`
  fill: var(--light-gray);
`;

const StyleResentlyBuy = styled(ResentlyBuy)`
  stroke: var(--light-gray);
`;

const StyleSeaview = styled(Seaview)`
  stroke: var(--light-gray);
`;

const Container = styled.div<{ $isMobile: boolean; $isWhitelabel: boolean }>`
  font-style: normal;
  font-weight: 400;
  font-size: var(--small-text-size);
  line-height: 1.16em;
  color: var(--light-gray);
  z-index: 2;
  width: 100%;
  & > * + * {
    margin-top: 0.416em;
  }

  ${({ $isMobile, $isWhitelabel }) =>
    !$isMobile &&
    `
      display: flex;
      align-items: baseline;
      justify-content: ${$isWhitelabel ? 'space-evenly' : 'space-between'};
    `}
`;
export default DynamicDataArray;
